var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluetooth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8261 3.20206C14.8261 2.23327 15.8819 1.67874 16.6465 2.20019L16.7334 2.26517L24.5594 8.66414C25.1123 9.1162 25.1448 9.95168 24.657 10.4488L24.5594 10.5379L17.8791 16L24.5594 21.4621C25.1123 21.9141 25.1448 22.7496 24.657 23.2468L24.5594 23.3359L16.7334 29.7348C15.9932 30.34 14.9099 29.8438 14.8307 28.9078L14.8261 28.7979V18.4956L8.90729 23.3359C8.43267 23.7239 7.75373 23.6745 7.337 23.2404L7.25728 23.1485C6.87759 22.6634 6.926 21.9695 7.35068 21.5435L7.44062 21.4621L14.1209 15.9991L7.44062 10.5379C6.966 10.1498 6.86419 9.46199 7.18704 8.95118L7.25728 8.85152C7.63698 8.36642 8.30999 8.26237 8.80978 8.59234L8.90729 8.66414L14.8261 13.5035V3.20206ZM17.1077 18.404V26.1818L21.9538 22.2929L17.1077 18.404ZM17.1077 5.81818V13.596L21.9538 9.70707L17.1077 5.81818Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetooth);
export default __webpack_public_path__ + "static/media/bluetooth.ea964934680dfd8eb0e86510089649e9.svg";
export { ForwardRef as ReactComponent };